var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestiongrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28476 8.57621C4.28476 6.2129 6.2062 4.29145 8.56952 4.29145H10.7119C13.0752 4.29145 14.9967 6.2129 14.9967 8.57621V8.81723C14.9967 10.2767 14.2535 11.6358 13.0283 12.4191L10.2031 14.2334C8.51596 15.318 7.49833 17.1859 7.49833 19.1877V19.2814C7.49833 20.4664 8.4557 21.4238 9.6407 21.4238C10.8257 21.4238 11.7831 20.4664 11.7831 19.2814V19.1877C11.7831 18.6387 12.0643 18.1299 12.5195 17.8353L15.3448 16.021C17.7951 14.441 19.2814 11.7295 19.2814 8.81053V8.56951C19.2814 3.8362 15.4452 0 10.7119 0H8.56952C3.8362 0.00669493 0 3.84289 0 8.57621C0 9.76121 0.957375 10.7186 2.14238 10.7186C3.32738 10.7186 4.28476 9.76121 4.28476 8.57621ZM9.6407 30C10.3509 30 11.0321 29.7179 11.5343 29.2156C12.0365 28.7134 12.3187 28.0323 12.3187 27.322C12.3187 26.6118 12.0365 25.9306 11.5343 25.4284C11.0321 24.9262 10.3509 24.6441 9.6407 24.6441C8.93046 24.6441 8.24931 24.9262 7.74709 25.4284C7.24487 25.9306 6.96273 26.6118 6.96273 27.322C6.96273 28.0323 7.24487 28.7134 7.74709 29.2156C8.24931 29.7179 8.93046 30 9.6407 30Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestiongrey);
export default __webpack_public_path__ + "static/media/question grey.6c8f1558223f45b15418339600f271e1.svg";
export { ForwardRef as ReactComponent };